<template>
    <div>
        <div class="row">
            <div class="col-8">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>{{buildingName}} / Messages</span>

                </div>
            </div>
            <div class="col-4 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <!--<span style="margin-right:5px">Add New Unit</span>
                        <router-link class="btn btn-table" :to="{
                  name: 'property',
                  params: { buildingId: buildingId, buildingName: buildingName },
                }"><i class="fas fa-plus"></i></router-link>-->
                    <span style="
width: 30px;
height: 30px;
border-radius: 5px;
            background-color: #007DFC;
            color: white;
            display: inline-block;
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
            margin-right:8px;
          ">
                        <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                    </span>

                    <span @click="showSearch()"
                          style="
                          width: 30px;
                          height: 30px;
                          border-radius: 5px;
                          background-color: #007DFC;
                          color: white;
                          display: inline-block;
                          padding-left: 5px;
                          padding-right: 5px;
                          text-align: center;
                          cursor:pointer;

                          ">
                        <i class="fa fa-search" style="margin-top:7px;" aria-hidden="true"></i>
                    </span>
                    <input type="text" v-if="visibleSearch" class="form-control" name="searchText" id="searchText" style=" display: inline-block; width: 250px; height: 30px;" v-model="filter">
                    <userMenu />
                </div>
            </div>
        </div>

        <div class="row">

            <div class="offset-md-9 col-3 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <span style="margin-right:5px">Send New Message</span>
                    <router-link class="btn btn-table" :to="{
            name: 'message',
            params: { buildingId: buildingId, buildingName: buildingName },
          }"><i class="fas fa-plus"></i></router-link>
                </div>
            </div>
        </div>

        
        <div class="row">
            <div class="col-md-4 col-sm-12 col-12 px-1 py-2">
                <div class="table-responsive">
                    <table class="table table-condensed"
                           id="tblThread"
                           width="100%"
                           cellspacing="0">
                        <thead >
                            <tr>
                                <th scope="col">Subject</th>
                                <th scope="col">Received</th>
                                <th scope="col">Creator</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="message in messages"
                                v-bind:key="message.id"
                                class="clickable-row"
                                :class="{ 'unread-message-row': message.numberOfUnseenMessages > 0  }"
                                v-on:click="selectMessageThread(message)">
                                <td scope="col">{{ message.subject }}</td>
                                <td>{{ customFormatter(message.latestReceivedDate) }}</td>
                                <td>{{ message.creator }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- chat is here -->
            <div class="col-md-6 col-sm-8 col-12 px-1 py-2 d-none" id="divChat">
                <div class="container-notifications py-2 px-3 border rounded align-items-center mb-2">
                    <div class="font-weight-bold" id="lblThreadInfo">
                        {{ threadSubject }}
                    </div>
                </div>
                <!-- here is the scroll option -->
                <div>
                    <!--  <ul v-chat-scroll="{always: false, smooth: true}" class="container-notifications px-0 py-3 border rounded mb-1" style="max-height:486px;height:486px; overflow-y:scroll" id="divMessages" >-->
                    <transition-group v-chat-scroll="{ always: false, smooth: true }"
                                      class="container-notifications px-0 py-3 border rounded mb-1"
                                      style="max-height: 486px; height: 486px; overflow-y: scroll;"
                                      id="divMessages"
                                      name="slide-up"
                                      tag="ul"
                                      appear>
                        <li v-for="messageTxt in messages" :key="messageTxt"></li>
                    </transition-group>
                    <!--  </ul> -->
                </div>
                <div class="container-notifications py-2" style="background-color:transparent;">
                    <div class="input-group">
                        <input @keydown.enter="sendMessage"
                               type="text"
                               style="margin-right: 6px;"
                               class="form-control bg-light text-dark"
                               v-model="messageTxt"
                               placeholder="Write a Message..."
                               id="txtMessage" />

                        <div class="input-group-append">
                            <button v-on:click="sendMessage"
                                    @keydown.enter="sendMessage"
                                    class="btn btn-default bg-success text-light"
                                    type="button"
                                    id="btnSend"
                                    v-bind:disabled="!messageIsNotEmpty">
                                <i class="fas fa-paper-plane fa-sm"></i>
                                <span class="small">Send</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-2 col-sm-4 col-12 px-1 py-2 d-none" id="divUsers">
                <div class="container-notifications py-2 px-3 border rounded-top align-items-center mb-0">
                    <div class="font-weight-bold text-center">Participants</div>
                </div>
                <div class="container-notifications px-0 py-3 border rounded-bottom mb-2"
                     style="max-height: 536px; height: 536px; overflow-y: scroll;"
                     id="divParticipants"></div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.unreadFontStyle {
  font-weight: 600;
  /* text-align: center; */
}
@media (min-width: 600px) {
  .rightFloat {
    float: right;
    text-align: right;
  }
}
</style>

<script>
import { mapState } from "vuex";
import { format, parseISO } from "date-fns";
import { authenticationService } from "@/_services";
import { crono } from "@/plugins/crono";
import { escapeHtml, escapeHtmlWithBreaks } from "@/_helpers/escape";
import {Howl,Howler} from "howler";
export default {
  mixins: [crono],
  data: function () {
    return {
      currentUser: null,
      messages: [],
      messageTxt: "",
      threadSubject: "",
      messagesArray: [],
      buildingId: 0,
    //  buildingName: "",
      message: {},
      selectedThread: 0,
      unreadMessages: 0,
      fetchingUnseen: false,
    };
  },
  cron: {
    time: 5000,
    method: "fetchUnseenMessages",
  },
  mounted() {
    this.buildingId = this.$route.params.buildingId;
    //this.buildingName = this.$route.params.buildingName;

    /*  $('#tblThread tbody').on('click', 'tr', function () {
            var thread = table.row(this).data();
           
            //notifications.setSelectedThread(thread);
            //notifications.setCurrentPage(1);
            $('#divChat,#divUsers').removeClass('d-none');
            $('#lblThreadInfo').html(thread.subject + ' - ' + thread.createdAt);
            $('#divMessages').empty();
            $vm0.$children[0].$children[2].selectThread(thread.threadId)
            $vm0.$children[0].$children[2].getThreadMessages(thread.threadId)
            $vm0.$children[0].$children[2].getParticipants(thread.threadId)
            //this.getThreadMessages(thread.threadId)
          //  SimpleAjax('/Notification/GetThreadMessages/' + thread.id, 'GET', null, onSuccess);
          //  SimpleAjax('/Notification/GetParticipants/' + thread.id, 'GET', null, onSuccess);
        });*/

    //this.buildingName = this.$route.params.buildingName;
    this.fetchStatement();
  },
  created() {
    authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
  },
  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    messageIsNotEmpty: function () {
      if (this.messageTxt) {
        return true;
      }

      return false;
    },
    anyUnreadMessages: function () {
      if (this.unreadMessages == 0) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    selectMessageThread: function (message) {
      $("#divChat,#divUsers").removeClass("d-none");
      this.threadSubject =
        message.subject + " - " + this.customFormatter(message.createdAt);

      $("#divMessages").empty();
      message.numberOfUnseenMessages = 0
      this.selectThread(message.threadId);
      this.getThreadMessages(message.threadId);
      this.getParticipants(message.threadId);
    },
    selectThread: function (id) {
      this.selectedThread = id;
    },
    keyPress: function (e) {
      if (e.keyCode === 13) this.sendMessage();
    },

    sendMessage: function () {
      //  this.sendingMessage = true;
      let canSend = this.messageTxt;
      var divId = "divMessages";
      if (canSend) {
        this.$http
          .post("/messages", {
            body: this.messageTxt,
            userId: this.currentUser.id,
            threadId: this.selectedThread,

            //   contact:this.contact
          })
          .then(
            (response) => {
              var m = { body: this.messageTxt, time: "", id: 0 };
              this.messageTxt = "";
              var template = this.getMessageItemBox(m, true, "msgNumTemp");
              $("#" + divId).append(template);

              /* this.$nextTick(() => {
                        this.scrollToBottom()*/
              //})
            },
            (error) => {
              console.log("Message sending failed with error:", error);
            }
          );
      }
    },

    getThreadMessages: function (threadId) {
      this.mute = true;
      //this.buildingId = 3;
      var request =
        "/messages/threadmessage?threadId=" +
        threadId +
        "&userId=" +
        this.currentUser.id;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.showMessages(data.response.data);
        });
    },
    getParticipants: function (threadId) {
      this.mute = true;
      //this.buildingId = 3;
      var request = "/messages/participants?threadId=" + threadId;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.showParticipants(data.data);
        });
    },
    showParticipants: function (participants) {
      $("#divParticipants").empty();

      var count = participants.length;
      if (count == 0) return;

      // SHOW
      // var thread = notifications.getSelectedThread();

      for (var i = 0; i < count; i++) {
        var p = participants[i],
          isMyId = p.id === this.currentUser.id,
          bgClass = isMyId ? "bg-dark" : "bg-greyish",
          name = isMyId ? "You" : escapeHtml(p.name);

        var template =
          '<div class="row-notifications mx-2 my-2 align-items-center">' +
          /* '<div class="">' +
                        '<div class="border rounded mx-2 my-1 p-2" style="width:30px;height:30px;"><div class="rounded-circle ' + bgClass + '" style="width: 12px;height: 12px;vertical-align: middle;margin: auto;margin-top: 3px;"></div></div>' +
                        '</div>' +*/
          '<div class="c">' +
          '<span class="font-weight-bold d-inline-block text-truncate" style="max-width: 100px;">' +
          name +
          "</span>" +
          "</div>" +
          "</div>";

        $("#divParticipants").append(template);
      }
    },
    showMessages: function (messages) {
      var divId = "divMessages";
      var page = 1;
      var count = messages.length;
      if (count == 0) return;

      // SHOW
      var thread = 1,
        append = page == null || page == 1,
        lowerBound = append ? 0 : count - 1;

      var arrUnreadMessageId = [];
      for (
        var i = lowerBound;
        append ? i < count : i >= 0;
        append ? i++ : i--
      ) {
        var m = messages[i],
          isMyId = m.userId === this.currentUser.id;

        if (m.seen === false) arrUnreadMessageId.push(m.id);

        if ($("#msgNum" + m.id).length == 0) {
          // ADD
          var template = this.getMessageItemBox(m, isMyId, "msgNum");
          if (append) {
            // FOR FIRST PAGE AND UNSEEN MESSAGES
            $("#" + divId).append(template);
          } else {
            // FOR NEXT PAGES
            $("#" + divId).prepend(template);
          }
        } else {
          // UPDATE
        }

        if(arrUnreadMessageId.length > 0)
        {
          //this.buildingId = 3;
      var request =
        "/messages/markseen?id=" +
        this.buildingId +
        "&userId=" +
        this.currentUser.id;
      this.$http
        .put(request, {
          userId: this.currentUser.id,
          unreadMessages:arrUnreadMessageId
        }).then(()=>{
          this.unreadMessages = this.unreadMessages - arrUnreadMessageId.length
         
          arrUnreadMessageId = []
        })
        }

        // SCROLL TO SEE NEW MESSAGE
        /* if (append)
                         ScrollChatBoxToBottom(divId);
 
                     // MARK UNSEEN MESSAGES TO SEEN
                     if (arrUnreadMessageId.length > 0) {
                         var kvPair = [],
                             token = GetFormToken();
                         kvPair.push(EncodeParameter('threadId', thread.id));
                         kvPair.push(EncodeParameter('messageIds', arrUnreadMessageId.join()));
                         kvPair.push(EncodeParameter('__RequestVerificationToken', token));
                         var data = kvPair.join('&');
                         SimpleAjax('/Notification/MarkSeen', 'POST', data, onSuccess);
                     }*/
      }
    },
    getMessageItemBox: function (m, isMyId, msgDivPrefix) {
      var bgClass = isMyId ? "bg-success text-light" : "bg-info text-dark",
        align = isMyId ? "float-right" : "float-left",
        body = escapeHtmlWithBreaks(m.body),
        name = isMyId ? "You" : escapeHtml(m.name),
        time = escapeHtml(m.time),
        msgNum = msgDivPrefix + m.id;

      var template =
        '<div class="' +
        align +
        '" id="' +
        msgNum +
        '" style="max-width:65%; min-width: 40px; display: inline-block; clear: both">' +
        '<p class="rounded p-3 mb-1 ' +
        bgClass +
        '">' +
        body +
        "</p>" +
        "<span >" +
        name +
        '&nbsp;</span> <span class="font-weight-bold float-right">' +
        time +
        "</span>" +
        "<br>" +
        "</div>";
      return template;
    },
    playSound: function () {
      var sound = new Howl({
        src: "/audio/when.mp3",
      });

      sound.play();
    },
    fetchUnseenMessages: function () {
      if (this.fetchingUnseen || !this.currentUser) return;
      this.fetchingUnseen = true;
      this.mute = true;

      //this.buildingId = 3;
      var request =
        "/messages/unseenmessages?buildingId=" +
        this.buildingId +
        "&userId=" +
        this.currentUser.id;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then((response) => {
          this.mute = false;

          var newUnseen = response.data.unseenMessages;
          if (newUnseen > this.unreadMessages) {
            
            this.unreadMessages = newUnseen;
            this.playSound();
            this.fetchStatement(
              this.messages.find(
                (element) => element.threadId == this.selectedThread
              )
            );
          }
        })
        .catch((error) => {
          console.log("Fetching unseen messages failed with error:", error);
        })
        .finally(() => {
          this.fetchingUnseen = false;
        });
    },
    fetchStatement: function (selectedThreadMessage) {
      this.mute = true;
this.messages = []
      //this.buildingId = 3;
      var request =
        "/messages/building?id=" +
        this.buildingId +
        "&userId=" +
        this.currentUser.id;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.messages = data.messages;
          if (this.messages.length > 0) {
            if (selectedThreadMessage)
              this.selectMessageThread(selectedThreadMessage);
            else this.selectMessageThread(this.messages[0]);
          }
        });
    },

    customFormatter(date) {
      //alert(moment(date).format('dd/MM/YYYY'));
      //return date | moment("dddd, MMMM Do YYYY")
      return format(parseISO(date), "dd/MM/yyyy");
    },
  },

  props: {
    drawer: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
